'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogConstants = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dialogConstants = exports.dialogConstants = {
  paddingX: (0, _reactackleCore.bmodule)(2),
  paddingY: (0, _reactackleCore.bmodule)(2),
  paddingYSmall: (0, _reactackleCore.bmodule)(1.5)
};

exports.default = {
  window: {
    minWidth: 280,
    maxWidth: 640,
    backgroundColor: _reactackleCore.colorWhite,
    borderRadius: _reactackleCore.radiusDefault,
    zIndex: _reactackleCore.zIndexModal,
    margin: (0, _reactackleCore.bmodule)(1)
  },

  sideRegion: {
    backgroundColor: _reactackleCore.colorPaletteGrey200,
    maxWidth: 320
  },

  closeButton: {
    width: 40,
    height: null,
    imgSize: 24,
    iconElement: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'inherit' }),

    style: {
      color: _reactackleCore.bodyFontColor,
      opacity: 0.46,

      hover: {
        color: _reactackleCore.bodyFontColor,
        opacity: 1
      },

      focus: {
        color: _reactackleCore.bodyFontColor,
        opacity: 0.7
      },

      modalWithTransparentBg: {
        color: _reactackleCore.colorWhite,
        opacity: 0.46,

        hover: {
          color: _reactackleCore.colorWhite,
          opacity: 1
        },

        focus: {
          color: _reactackleCore.colorWhite,
          opacity: 0.7
        }
      }
    }
  },

  title: {
    paddingX: dialogConstants.paddingX,
    paddingY: dialogConstants.paddingY,
    fontSize: _reactackleCore.fontSizeTitle,
    lineHeight: 1.3,
    color: _reactackleCore.bodyFontColor,
    fontWeight: _reactackleCore.fontWeightSemibold
  },

  subtitle: {
    subtitleTitleSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.3,
    color: _reactackleCore.fontColorMedium,
    fontWeight: _reactackleCore.fontWeightNormal
  },

  content: {
    paddingX: dialogConstants.paddingX,
    paddingY: dialogConstants.paddingY,
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5,
    color: _reactackleCore.bodyFontColor,
    fontWeight: _reactackleCore.fontWeightNormal,
    similarTextBlockSpacing: (0, _reactackleCore.bmodule)(1),

    borderWidth: 1,
    borderColor: _reactackleCore.colorBorder
  },

  actions: {
    paddingX: dialogConstants.paddingX,
    paddingY: dialogConstants.paddingY
  },

  actionItem: {
    marginX: '0.5em',
    marginY: (0, _reactackleCore.bmodule)(0.5)
  },

  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    zIndex: 1
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/styles/theme.js
// module id = 670
// module chunks = 0